import {SubscriptionInfo} from '../../shared/models/subscription-info.model';

export class UpdateSubscriptionInfo {
  static readonly type = '[Subscription Info] Update';

  constructor(public payload: SubscriptionInfo) {}
}
